import dayjs from 'dayjs';
import type { FilterLineType } from '../../../../components/new-design/vyTableFilter';
import type { JournalEntryRow } from './flatten-journal-entries';
import { matchesJournalEntryFilter } from './journal-entries-filter-fields';

export type JournalEntriesFilters = {
  month: Date | null;
  customerSearch: string;
  filters: FilterLineType[];
};

export function applyJournalEntriesFilters(
  rows: JournalEntryRow[],
  filters: JournalEntriesFilters,
): JournalEntryRow[] {
  const month = filters.month ? dayjs(filters.month).format('YYYY-MM') : null;
  const customerSearch = filters.customerSearch.trim().toLowerCase();

  return rows.filter((row) => {
    if (month && row.periodMonth !== month) return false;
    if (customerSearch && !row.customerName.toLowerCase().includes(customerSearch)) return false;
    for (const filter of filters.filters) {
      if (!matchesJournalEntryFilter(row, filter)) return false;
    }
    return true;
  });
}
